import React from 'react'

import {
    Button,
    Modal,
    Row,
    Input
} from 'antd'

class AddCategory extends React.Component{

    state = {
        visible: false,
        render: false,
        title: ''
    }

    render(){

        const { visible, render, title } = this.state

        return(
            <div>
                {render && 
                <Modal
                    afterClose={()=>this.setState({ render: false})}
                    onCancel={()=>this.setState({visible: false})}
                    centered
                    footer={null}
                    closable={false}
                    visible={visible}
                >
                    <Input
                        autoFocus
                        onPressEnter={this.handleSubmit}
                        value={title}
                        onChange={this.handleChange}
                    />
                    <Row type="flex" justify="end" style={{marginTop: 8}}>
                        <b>Press Enter</b>
                    </Row>
                </Modal>}
                <Button
                    onClick={()=>this.setState({
                        visible: true,
                        render: true
                    })}
                >{this.props.buttonText || 'Add'}</Button>
            </div>
        )
    }

    handleChange = (e) => {
        this.setState({
            title: e.target.value
        })
    }

    handleSubmit = () => {
        const { title } = this.state

        this.setState({ 
            visible: false,
            render: false,
            title: ''
        }, () => this.props.handleSubmit(title))
        // this.props.handleSubmit(title)

    }
    
}

export default AddCategory


// WEBPACK FOOTER //
// ./src/components/docs/add-category.js